module.exports = __webpack_public_path__ + "img/cf.f9fa8a7c.svg";